export default __webpack_public_path__ + "static/media/Fantasy_01.e5615ba6.png";